
import { mapActions, mapGetters, mapState } from 'vuex';
import PaginatedProductResourceView from '@/mixins/PaginatedProductResourceView';
import ThumbnailRatio from '@/enums/ThumbnailRatio';
import ProductItemDisplayField from '@/enums/ProductItemDisplayField';

export default {
  i18nComponentKey: 'WidgetProductsProductThumbnail.components.ProductThumbnail',
  name: 'ProductThumbnail',
  mixins: [PaginatedProductResourceView],
  props: {
    gutter: {
      type: Number,
      default: 16
    },
    rowGap: {
      type: Number,
      default: 32
    }
  },
  computed: {
    ...mapGetters('widget', ['device']),
    ...mapState('product', ['categoryName']),
    ...mapState('widget', ['widget', 'isMobile']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('productCategories', ['productCategories']),
    ...mapState('window', ['windowService']),
    defaultResourceParams() {
      return {
        fields: [
          this.showCategoryName ? 'products.category_ids' : '',
          this.showReviews ? 'products.reviews' : ''
        ]
          .filter(v => v)
          .join(',')
      };
    },
    isThumbnailRatioSquare() {
      return this.widget.product_thumbnail_ratio === ThumbnailRatio.SQUARE;
    },
    showCategoryName() {
      return (
        (this.widget.item_display_fields & ProductItemDisplayField.CATEGORY) !==
        0
      );
    },
    showProductDetail() {
      return (
        (this.widget.item_display_fields &
          ProductItemDisplayField.PRODUCT_DETAIL) !==
        0
      );
    },
    showReviewSummary() {
      return (
        (this.widget.item_display_fields &
          ProductItemDisplayField.REVIEW_SUMMARY) !==
        0
      );
    },
    showReviews() {
      return (
        (this.widget.item_display_fields & ProductItemDisplayField.REVIEWS) !==
          0 && this.widget.reviews_per_product > 0
      );
    },
    styleProps() {
      const { background_color, posts_per_line } = this.widget;
      return {
        backgroundColor: background_color,
        '--layout-column': posts_per_line,
        '--column-gap': `${this.gutter}px`
      };
    },
    minCardWidth() {
      return this.device === 'pc' ? 100 : 0;
    }
  },
  methods: {
    ...mapActions('widget', ['openReviewPopup']),
    imageUrl(product) {
      if (
        this.widget.display_original_product_image &&
        product.image.source_url
      )
        return product.image.source_url;
      else if (this.isThumbnailRatioSquare) return product.image.middle_url;
      else return product.image.url;
    },
    productCategoryName(categoryIds) {
      if (this.categoryName) return this.categoryName;

      const categoryIdsSet = new Set(categoryIds);
      return this.productCategories.find(e => categoryIdsSet.has(e.id))?.name;
    },
    onSubmitSearchBar(params) {
      this.searchResource(params);
    },
    onClickProductInfo(event, url) {
      if (event.metaKey || event.ctrlKey) return;

      this.windowService.redirectTo(url);
    }
  }
};
